// Lone Rider — Variant swap at add-to-cart
//
// A hardcoded "the customer picks X, the cart gets Y" substitution.
//
// Currently one pair, on MTL9: picking variant 58642974703990 posts
// 58814765662582 to the cart instead.
//
// The swap happens at SUBMIT TIME ONLY, deliberately. The page keeps showing the
// variant the customer actually chose — its price, its gallery, its ?variant= in
// the URL, whatever the configurator resolved — because that is the variant they
// asked for; only the id that leaves in the POST body is rewritten. Swapping any
// earlier (in theme.Variants' master select, say) would need the replacement to be
// an in-stock option of the same product, which is exactly the assumption a swap
// like this is here to avoid: the replacement may live on another product, or be
// one the select never rendered.
//
// Both ways of adding these products to the cart end in a real <form> POST to
// /cart/add — the PDP's product form (snippets/product-form.liquid) and the sticky
// bar's own form (snippets/sticky-cart-bar.liquid), whether the theme's
// theme.AjaxProduct, lr-make-filter.js or a plain browser submit carries it. Each
// of those builds its body from `new FormData(form)` inside its own submit
// handler, so a listener on `document` in the CAPTURE phase runs before all of
// them and every one of them picks up the rewritten value. Capture also survives
// the `stopImmediatePropagation()` that the sticky bar's handler calls.
//
// Not covered: dynamic checkout ("Buy it now" / Shop Pay), which reads the form
// itself at click time rather than submitting it. MTL9 has those buttons switched
// off (`show_dynamic_checkout: false` in templates/product.mtl9.json), so there is
// nothing to cover today — but turning them back on for a product listed below
// would let the original variant through.
//
// Inert everywhere else: variant ids are unique shop-wide, so a page that never
// posts one of the keys below never notices this file. Removing a pair — or the
// whole map — turns the swap off with no other change.
(() => {
  'use strict';

  // Raw Shopify variant ids: what the customer chose -> what goes in the cart.
  // Strings, because that is what form fields hold.
  const SWAPS = {
    // MTL9
    '58642974703990': '58814765662582'
  };

  if (!Object.keys(SWAPS).length) return;

  // `{% form 'product' %}` gives every one of these an action of /cart/add and a
  // hidden form_type=product. Either is enough to recognise; both are checked so a
  // hand-rolled form (the sticky bar's) still matches.
  function isCartAddForm(form) {
    const action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') !== -1) return true;
    const formType = form.elements.namedItem('form_type');
    return !!formType && String(formType.value) === 'product';
  }

  // Every control the form submits as `id`. Read off form.elements rather than with
  // querySelectorAll, because the sticky bar's id input sits in the panel OUTSIDE
  // its form and belongs to it only through a `form="..."` attribute — which
  // form.elements honours and a descendant selector does not.
  function idControls(form) {
    return Array.from(form.elements).filter((el) => el.name === 'id');
  }

  // Takes the chosen control out of the submission and posts the replacement in its
  // place, returning the undo.
  //
  // A <select> cannot simply be reassigned: the master select holds an <option> per
  // in-stock variant of its own product and nothing else, so `select.value = target`
  // would silently do nothing whenever the replacement is not one of them. So the
  // control is disabled (disabled controls are left out of FormData) and a hidden
  // input carries the replacement. Appended to the form itself, never next to the
  // control, so a control that lives outside the form still ends up swapped.
  function swap(form, control, target) {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'id';
    hidden.value = target;
    form.appendChild(hidden);
    control.disabled = true;

    return () => {
      hidden.remove();
      control.disabled = false;
    };
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isCartAddForm(form)) return;

    const undos = [];
    idControls(form).forEach((control) => {
      const target = SWAPS[String(control.value)];
      if (target) undos.push(swap(form, control, target));
    });
    if (!undos.length) return;

    // Put the form back the way it was. Every handler that matters has read it by
    // the time this runs: the theme's AJAX add builds its FormData synchronously
    // inside its own submit handler, and a native submit has already left the page.
    // Restoring keeps the form honest for a second add after an AJAX one, and keeps
    // a disabled master select from confusing theme.VariantAvailability.
    setTimeout(() => undos.forEach((undo) => undo()), 0);
  }, true);
})();
